/** @format */
import { request } from 'src/utils'
const API = {
  getGrafanaList: '/monitor/?Action=ListGrafanaInstances&Version=2025-01-01', // 获取grafana实例列表
  createGrafanaInstance: '/monitor/?Action=CreateGrafanaInstance&Version=2025-01-01'
}

// 获取
export const getGrafanaInstanceList = async () => {
  const result = await request(API.getGrafanaList, {
    method: 'GET'
  })
  return result?.data || {}
}

// 创建
export const createGrafanaInstance = async () => {
  const result = await request(API.createGrafanaInstance, {
    method: 'POST'
  })
  return result?.data || {}
}

export default API
